module.exports = __webpack_public_path__ + "img/snowy-6.67d63a14.svg";